// Apolo IDE — Electron bridge helper.
//
// `window.apolo` is exposed by preload.cjs only when running inside the
// Electron renderer. In Vite dev (browser) and in test (jsdom) it is
// undefined — callers should treat the bridge as optional and fall back
// to Worker API or display "Electron-only feature" messaging.

export function hasElectronBridge() {
  return typeof window !== 'undefined' && !!window.apolo;
}

export function getElectronBridge() {
  if (!hasElectronBridge()) return null;
  return window.apolo;
}

export const ELECTRON_REQUIRED_MESSAGE =
  'Esta funcionalidade requer o Electron — rode `npm run dev` no workspace apolo/ ou abra o build empacotado.';
